import { render, staticRenderFns } from "./MbCustomRoulette.vue?vue&type=template&id=3183c2ea&scoped=true&"
import script from "./MbCustomRoulette.vue?vue&type=script&lang=js&"
export * from "./MbCustomRoulette.vue?vue&type=script&lang=js&"
import style0 from "./MbCustomRoulette.vue?vue&type=style&index=0&id=3183c2ea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183c2ea",
  null
  
)

export default component.exports